export default __webpack_public_path__ + "static/media/George_W_Bush_0042.7cc9d094.jpg";